import { memo } from 'react';
import Form from 'react-bootstrap/Form';
import Col from 'react-bootstrap/Col';

function FundingOutstandingAmountForm({ fundingOutstandingAmount }) {
  return (
    <>
      <Col md={2} className="bo-same-line">
        <Form.Label>Outstanding Amount:</Form.Label>
      </Col>
      <Col md={1} className="bo-same-line">
        <Form.Control
          align="right"
          className="bo-input"
          type="text"
          name="outstandingAmount"
          id="outstandingAmount"
          value={fundingOutstandingAmount}
          readOnly
        />
      </Col>
      <Col md={3} className="bo-same-line" />
    </>
  );
}
export default memo(FundingOutstandingAmountForm);
